import request, { _POST } from "@/services/request";
import {
  DakeCreatePopupConfigReq,
  DakeOperationLogListReq,
  DakeOperationLogListRsp,
  DakePopupConfigInfoReq,
  DakePopupConfigInfoRsp,
  DakePopupConfigListReq,
  DakePopupConfigListRsp,
  DakePopupConfigOffShelfReq,
} from "@/data-contracts";

/**
 * 创建弹窗配置
 * /admin/popup/config/create
 */
const createPopupConfig = (params: DakeCreatePopupConfigReq) => {
  return request<null, DakeCreatePopupConfigReq>(_POST, "/admin/popup/config/create")(params);
};

/**
 * 弹窗列表
 * /admin/popup/config/list
 */
const listPopupConfig = (params?: DakePopupConfigListReq) => {
  return request<DakePopupConfigListRsp, DakePopupConfigListReq>(_POST, "/admin/popup/config/list")(params ?? {});
};

/**
 * 弹窗信息
 * /admin/popup/config/info
 */
const getPopupConfigInfo = (params: DakePopupConfigInfoReq) => {
  return request<DakePopupConfigInfoRsp, DakePopupConfigInfoReq>(_POST, "/admin/popup/config/info")(params);
};

/**
 * 下架弹窗
 * /admin/popup/config/off/shelf
 */
const offShelfPopupConfig = (params: DakePopupConfigOffShelfReq) => {
  return request<null, DakePopupConfigOffShelfReq>(_POST, "/admin/popup/config/off/shelf")(params);
};

/**
 * 弹窗操作日志
 * /admin/operation/log/list
 */
const listPopupOperationLog = (params: DakeOperationLogListReq) => {
  return request<DakeOperationLogListRsp, DakeOperationLogListReq>(_POST, "/admin/operation/log/list")(params);
};

const popupApis = {
  createPopupConfig,
  listPopupConfig,
  getPopupConfigInfo,
  offShelfPopupConfig,
  listPopupOperationLog,
};

export default popupApis;
